/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowSquareOut: {
  name: 'arrow_square_out';
  data: string;
} = {
  name: 'arrow_square_out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M13.875 3.75a.75.75 0 0 1 .75-.75h5.624a.75.75 0 0 1 .75.75L21 9.376a.75.75 0 0 1-1.5 0V5.561l-5.472 5.472a.75.75 0 0 1-1.061-1.06L18.439 4.5 14.625 4.5a.75.75 0 0 1-.75-.75Z" fill="currentColor"/><path d="M4.5 6A1.5 1.5 0 0 0 3 7.5v12A1.5 1.5 0 0 0 4.5 21h12a1.5 1.5 0 0 0 1.5-1.5v-6a.75.75 0 0 0-1.5 0v6h-12v-12h6a.75.75 0 0 0 0-1.5h-6Z" fill="currentColor"/></svg>`
};
